export default __webpack_public_path__ + "static/media/apple_active.9872c630.png";